import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateActionModal } from "@features/modalSlice";
import $ from "jquery";
import {
    bypassWarningHandler,
    showModalHandler,
    toggleButtonLoader,
} from "@ts/modals";
import { Modal } from "antd";
import {
    generateCron,
    showAppliedFilters,
    updateRow,
    showActionModalHandler,
    getCurrency,
    getActiveModule,
    handleCronInput,
} from "@ts/utils";
import {
    updateSubmoduleElement,
    updateModuleAction,
    updateIsEdit,
    updateRule,
} from "@features/modalSlice";
import {
    Actions,
    IMainContext,
    IRulesData,
    IValue,
    IValueBoolean,
    TIsEdit,
    TRule,
    TUpdateRow,
} from "@ts/common-types";
import { GridApi } from "ag-grid-community";
import { AiOutlineClose } from "react-icons/ai";
import EditRulesFiltersModal from "./EditRulesFiltersModal";
import { useGetModulesData } from "@/hooks/AllCustomHooks";
import { map } from "underscore";
import { mainContext, RULE_OPTION_CONFIG } from "@/ts/constants";

type TAddRulesModal = { api: GridApi, canAddRule?: boolean };
type TActionModalDisp = { actionModalDisp: IValueBoolean };

type TSubmoduleElement = { submoduleElement: IValue };
type TModuleAction = { moduleAction: IValue };

const AddRulesModal: React.FC<TAddRulesModal> = ({ api, canAddRule }) => {
    const { cerbosPermissions } = useContext<IMainContext>(mainContext);
    const show = useSelector(
        (state: TActionModalDisp) => state.actionModalDisp.value
    );
    const submoduleElement = useSelector(
        (state: TSubmoduleElement) => state.submoduleElement.value
    );
    const moduleAction = useSelector(
        (state: TModuleAction) => state.moduleAction.value
    );
    const rule = useSelector((state: TRule) => state.rule.value);
    const isEdit = useSelector((state: TIsEdit) => state.isEdit.value);
    const isRuleSaveButtonDisabled = useSelector(
        (state: { isRuleSaveButtonDisabled: IValueBoolean }) =>
            state.isRuleSaveButtonDisabled.value
    );
    const [maxValue, setMaxValue] = useState<number>();
    const [minValue, setMinValue] = useState<number>();
    const [actionType, setActionType] = useState<string>();
    const [editRulesFilterModalData, setEditRulesFilterModalData] = useState({
        show: false,
        data: null
    });
    const [modalType, setModalType] = useState("query");
    const [isCronPresent, setIsCronPresent] = useState(false);
    const dispatch = useDispatch();
    const formRef = useRef(null);

    const [ruleOptions, setRuleOptions] = useState<any>({});

    const { featuresData } = useGetModulesData({
        type: "features"
    });

    const { ruleFeaturesData } = useGetModulesData({
        type: "rule-edit-features"
    });

    useEffect(() => {
        setRuleOptions(
            isEdit ? ruleFeaturesData : featuresData
        )
    }, [ruleFeaturesData, featuresData, isEdit]);

    useEffect(() => {
        if (show && isEdit) {
            if (rule.filter) {
                sessionStorage.setItem(
                    "appliedFilters",
                    JSON.stringify(rule.filter)
                );
                setActionType(rule.action_type);
                showAppliedFilters(
                    api,
                    editRulesFilterModalData.data || rule.filter,
                    `#actions-modal #modal-filters`,
                    true,
                    false
                );
                if (rule.cron_string) {
                    $("#cron_string").val(rule.cron_string);
                    setIsCronPresent(true);
                } else {
                    generateCron();
                }
            }
        } else {
            const activeFilters = JSON.parse(
                sessionStorage.getItem("activeFilters")
            );
            const defaultDateFilters = {
                report_date: {
                    filter: "Last 7 Days",
                    filterType: "date",
                    type: "relative",
                },
            };
            const currentDateFilter =
                JSON.parse(sessionStorage.getItem("currentDateFilter")) ||
                defaultDateFilters;

            if (show) {
                showAppliedFilters(
                    api,
                    {
                        ...activeFilters,
                        ...currentDateFilter,
                    },
                    `#actions-modal #modal-filters`,
                    true,
                    false
                );
            }
        }
    }, [isEdit, show, api, rule, editRulesFilterModalData.data]);

    useEffect(() => {

        $('#actions-modal input[type="radio"][name="actions"]').change(function () {
            if ($(this).is(':checked')) {
                $("#loader-backdrop").show();
                setTimeout(function () {
                    $("#loader-backdrop").hide();
                }, 500);

                const labelText = $(this).next('label').text();

                if (labelText === "New Rule") {
                    $("#rule-box").show();
                    setModalType("rule")
                } else {
                    $("#rule-box").hide();
                    setModalType("query");
                }
            }
        });

        $(`#actions-modal`)
            .find(`span.currency-code`)
            .text(` (${getCurrency()})`);
        switch (actionType) {
            case "percentIncrease":
                $("#threshold-max-div").css("display", "unset");
                $(".bid-change").css("display", "unset");
                $("#threshold-min-div").css("display", "none");
                $("#threshold-min").prop('required', false);
                $("#threshold-max").prop('required', true);
                break;
            case "percentDecrease":
                $("#threshold-min-div").css("display", "unset");
                $("#threshold-min").prop('required', true);
                $("#threshold-max").prop('required', false);
                $(".bid-change").css("display", "unset");
                $("#threshold-max-div").css("display", "none");
                break;
            case "pause":
            case "pauseKeywords":
            case "pauseAds":
            case "moveToSuggestedMin":
            case "moveToSuggestedMax":
            case "moveToSuggestedAvg":
            case "markNegative":
                $("#threshold-min-div").css("display", "none");
                $("#threshold-min").prop('required', false);
                $("#threshold-max").prop('required', false);
                $("#action-value").prop('required', false);
                $(".bid-change").css("display", "none");
                $("#threshold-max-div").css("display", "none");
                break;
        }
    });

    const handleClose = () => {
        dispatch(updateActionModal(false));
        dispatch(updateSubmoduleElement([]));
        dispatch(updateModuleAction([]));
        dispatch(updateIsEdit(false));
        dispatch(updateRule({}));
        if (isEdit) {
            toggleButtonLoader(rule.rule_id.toString(), true);
        }
        setEditRulesFilterModalData({
            show: false,
            data: null
        })
    };

    const advancedBtnHandler = () => {
        if ($("#freq-mode").text() === "Advanced") {
            $("#freq-label").text("CRON String");
            $("#freq-mode").text("Basic");
            $("#frequency-label").css("display", "none");
            $("#frequency-value").css("display", "none");
            $("#frequency-units").css("display", "none");
            $("#cron_string").css("display", "unset");
        } else {
            $("#freq-label").text("Frequency");
            $("#freq-mode").text("Advanced");
            $("#cron_string").css("display", "none");
            $("#frequency-label").css("display", "unset");
            $("#frequency-value").css("display", "unset");
            $("#frequency-units").css("display", "unset");
        }
        generateCron();
    };

    function convertAsDbResponse(data: IRulesData) {
        return {
            action_type: data.action ? data.action.type : null,
            action_value: data.action ? data.action.value : null,
            frequency_value: data.frequency ? data.frequency.value : null,
            frequency_units: data.frequency ? data.frequency.unit : null,
            cron_string: data.cronString,
            filters: JSON.stringify(data.filters),
            module: data.module,
            name: data.name,
            threshold_min: data.threshold ? data.threshold.min || null : null,
            threshold_max: data.threshold ? data.threshold.max || null : null,
            exclude_yesterday: data.excludeYesterday,
            type: data.type,
        };
    }

    const validateForm = (event: any) => {
        event.preventDefault();
        return formRef.current.reportValidity();
    };

    const FooterComponent = () => {
        return <div className="d-flex">
            <span
                className="alert-panel alert fade show"
                style={{
                    padding: "0.1em",
                    height: "2em",
                    marginRight: "auto",
                    display: "grid",
                    placeContent: "center",
                }}
            />
            <button
                className="btn btn-secondary btn-close-big me-2"
                type="button"
                style={{ display: "grid", placeContent: "center" }}
                onClick={handleClose}
            >
                <span
                    className="loader spinner-border spinner-border-sm"
                    style={{ display: "none" }}
                    role="status"
                    aria-hidden="true"
                />
                <span className="content">Close</span>
            </button>
            <button
                className="btn btn-primary"
                id="save-action"
                disabled={isRuleSaveButtonDisabled}
                type="button"
                style={{ display: "grid", placeContent: "center" }}
                onClick={(e) => {
                    if(!validateForm(e)){
                        return;
                    }
                    const modifiedRule = structuredClone(rule);
                    if(editRulesFilterModalData.data){
                        modifiedRule.filter = editRulesFilterModalData.data;
                    }
                    isEdit
                        ? showModalHandler(
                            "actions-modal",
                            {
                                ...modifiedRule,
                                ...{
                                    module:
                                        submoduleElement[0]
                                            .moduleSlug ||
                                        submoduleElement[0].module,
                                    actions:
                                        moduleAction[0].actions ||
                                        moduleAction,
                                },
                                isEdit: true,
                            },
                            (data: IRulesData) => {
                                if (data) {
                                    updateRow({
                                        id: rule.rule_id,
                                        data: {
                                            ...modifiedRule,
                                            ...convertAsDbResponse(
                                                data
                                            ),
                                        },
                                        grid: { api: api },
                                    } as TUpdateRow);
                                }
                            }
                        )
                        : showActionModalHandler(getActiveModule().activeModule);
                }}
            >
                <span
                    className="loader spinner-border spinner-border-sm"
                    style={{ display: "none" }}
                    role="status"
                    aria-hidden="true"
                    id="save-btn-rules"
                />
                <span className="content" id="save-loader-rules">
                    Save changes
                </span>
            </button>
        </div>
    }

    return (
        <>
            {show && (
                <>
                    <Modal
                        title={
                            <div className="d-flex align-items-center pb-3">
                                <h4>{isEdit ? "Edit Rule" : "Save Actions"}</h4>
                            </div>
                        }
                        open={show}
                        onCancel={handleClose}
                        style={{ top: 50 }}
                        closeIcon={
                            <AiOutlineClose style={{ fontSize: "35px" }} />
                        }
                        footer={<FooterComponent />}
                    >
                        <div id="actions-modal">
                            <form
                                action=""
                                className="needs-validation row"
                                id="action-form"
                                ref={formRef}
                                onSubmit={validateForm}
                            >
                                <div className="d-flex">
                                    <div id="modal-filters"></div>
                                    {isEdit && (
                                        <input
                                            type="button"
                                            className="btn btn-xs text-primary"
                                            style={{ marginTop: "0.4rem" }}
                                            onClick={() => {
                                                setEditRulesFilterModalData(
                                                    (prev) => ({
                                                        ...prev,
                                                        show: true,
                                                    })
                                                );
                                            }}
                                            value="Edit Filters"
                                        />
                                    )}
                                </div>
                                <div id="actionType" className="mt-3">
                                    <div className="form-check form-check-inline">
                                        <input
                                            id="query"
                                            className="form-check-input"
                                            type="radio"
                                            name="actions"
                                            value="query"
                                            defaultChecked={
                                                isEdit
                                                    ? rule.type === "query"
                                                        ? true
                                                        : false
                                                    : true
                                            }
                                            disabled={isEdit ? true : false}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="query"
                                        >
                                            New Query
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            id="rule"
                                            className="form-check-input"
                                            type="radio"
                                            name="actions"
                                            value="rule"
                                            defaultChecked={
                                                isEdit
                                                    ? rule.type === "rule"
                                                    : false
                                            }
                                            disabled={isEdit || !canAddRule}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="rule"
                                        >
                                            New Rule
                                        </label>
                                    </div>
                                    <span className="float-end alert alert-secondary fade show p-0 px-2">
                                        module ={" "}
                                        <span id="module-name">
                                            {" "}
                                            {isEdit
                                                ? rule.module
                                                : getActiveModule()
                                                      .activeModule}
                                        </span>
                                    </span>
                                </div>

                                <div
                                    id="existing-action-warning"
                                    className="hide"
                                    style={{ display: "none" }}
                                >
                                    <div
                                        id="warning-message"
                                        className="text-danger"
                                    ></div>
                                    <div id="warning-actions">
                                        <button
                                            className="btn btn-outline-danger btn-sm"
                                            type="button"
                                            onClick={bypassWarningHandler}
                                        >
                                            Sure
                                        </button>
                                        <button
                                            className="btn btn-outline-danger btn-sm"
                                            type="button"
                                            onClick={handleClose}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>

                                <div id="action-configuration">
                                    <div className="my-3">
                                        <label
                                            htmlFor="name"
                                            className="form-label"
                                        >
                                            Name
                                        </label>
                                        <input
                                            id="action-name"
                                            className="form-control"
                                            type="text"
                                            data-instance-path="/name"
                                            name="action_name"
                                            aria-describedby="name validationNameFeedback"
                                            defaultValue={
                                                isEdit ? rule.name : null
                                            }
                                            required
                                        />
                                        <div
                                            id="validationNameFeedback"
                                            className="invalid-feedback"
                                        >
                                            | Please enter a name
                                        </div>
                                    </div>
                                    <div
                                        className="rule box"
                                        id="rule-box"
                                        style={{
                                            display:
                                                isEdit && rule.type === "rule"
                                                    ? "unset"
                                                    : "none",
                                        }}
                                    >
                                        <div className="mb-3">
                                            <label
                                                htmlFor="'action_type'"
                                                className="form-label"
                                            >
                                                Actions
                                            </label>
                                            <div className="input-group">
                                                <select
                                                    id="action-type"
                                                    className="form-select"
                                                    aria-describedby="action_type"
                                                    data-instance-path="/action/type"
                                                    name="action_type"
                                                    value={actionType}
                                                    onChange={(
                                                        e: React.ChangeEvent<HTMLSelectElement>
                                                    ) =>
                                                        setActionType(
                                                            e.target.value
                                                        )
                                                    }
                                                    required={
                                                        modalType === "rule"
                                                    }
                                                >
                                                    <option
                                                        value=""
                                                        disabled
                                                        selected
                                                    >
                                                        Select Action
                                                    </option>
                                                    {
                                                        ruleOptions &&
                                                            ruleOptions.rule &&
                                                            ruleOptions.rule.actions.length
                                                            ? map(ruleOptions.rule.actions, (action: Actions) => 
                                                                <option
                                                                    value={RULE_OPTION_CONFIG[action].value}
                                                                    selected={
                                                                        isEdit &&
                                                                        rule.action_type === RULE_OPTION_CONFIG[action].value
                                                                    }
                                                                >
                                                                    {" "}
                                                                    {RULE_OPTION_CONFIG[action].text}
                                                                </option>
                                                            )
                                                            : null
                                                    }
                                                </select>
                                                <span
                                                    className="input-group-text bid-change"
                                                    style={{ display: "none" }}
                                                >
                                                    by
                                                </span>
                                                <input
                                                    id="action-value"
                                                    className="form-control bid-change"
                                                    style={
                                                        isEdit
                                                            ? rule.action_type ===
                                                              "pause"
                                                                ? {
                                                                      display:
                                                                          "none",
                                                                  }
                                                                : {
                                                                      display:
                                                                          "unset",
                                                                  }
                                                            : actionType ===
                                                                  "percentIncrease" ||
                                                              actionType ===
                                                                  "percentDecrease"
                                                            ? {
                                                                  display:
                                                                      "unset",
                                                              }
                                                            : {
                                                                  display:
                                                                      "none",
                                                              }
                                                    }
                                                    data-instance-path="/action/value"
                                                    type="number"
                                                    aria-describedby="action_value"
                                                    name="action_value"
                                                    defaultValue={
                                                        isEdit &&
                                                        rule.type === "rule"
                                                            ? rule.action_value
                                                            : null
                                                    }
                                                    required={
                                                        modalType === "rule" &&
                                                        (actionType === "percentIncrease" ||
                                                            actionType === "percentDecrease")
                                                    }
                                                />
                                                <div
                                                    id="validationNameFeedback"
                                                    className="invalid-feedback"
                                                >
                                                    | Fill Action Value
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="mb-3 bid-change bid-change-max"
                                            id="threshold-max-div"
                                            style={{ display: "none" }}
                                        >
                                            <label
                                                htmlFor="max_value"
                                                className="form-label"
                                            >
                                                Maximum
                                                <span className="currency-code"></span>
                                            </label>
                                            <input
                                                id="threshold-max"
                                                type="number"
                                                className="form-control"
                                                data-instance-path="/threshold/max"
                                                name="max_value"
                                                required={modalType === "rule" && actionType === "percentIncrease"}
                                                min={0}
                                                step="0.0001"
                                                defaultValue={
                                                    isEdit
                                                        ? rule.threshold_max
                                                        : maxValue
                                                }
                                                onChange={(
                                                    e: React.ChangeEvent<HTMLInputElement>
                                                ) =>
                                                    setMaxValue(+e.target.value)
                                                }
                                            />
                                            <div
                                                id="validationNameFeedback"
                                                className="invalid-feedback"
                                            >
                                                Please Enter Maximum Value
                                            </div>
                                        </div>

                                        <div
                                            className="mb-3 bid-change bid-change-min"
                                            id="threshold-min-div"
                                            style={{ display: "none" }}
                                        >
                                            <label
                                                htmlFor="min_value"
                                                className="form-label"
                                            >
                                                Minimum
                                                <span className="currency-code"></span>
                                            </label>
                                            <input
                                                id="threshold-min"
                                                type="number"
                                                className="form-control"
                                                data-instance-path="/threshold/min"
                                                name="min_value"
                                                required={modalType === "rule" && actionType === "percentDecrease"}
                                                min={0}
                                                step="0.0001"
                                                defaultValue={
                                                    isEdit
                                                        ? rule.threshold_min
                                                        : minValue
                                                }
                                                onChange={(
                                                    e: React.ChangeEvent<HTMLInputElement>
                                                ) =>
                                                    setMinValue(+e.target.value)
                                                }
                                            />
                                            <div
                                                id="validationNameFeedback"
                                                className="invalid-feedback"
                                            >
                                                Please Enter Minimum Value
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <label
                                                htmlFor="select-frequency"
                                                className="form-label w-100"
                                            >
                                                <span className="d-flex justify-content-between w-100">
                                                    <span id="freq-label">
                                                        Frequency
                                                    </span>
                                                    <div
                                                        className="anchor-class"
                                                        id="freq-mode"
                                                        data-mode="Basic"
                                                        onClick={
                                                            advancedBtnHandler
                                                        }
                                                    >
                                                        Advanced
                                                    </div>
                                                </span>
                                            </label>
                                            <div
                                                className="input-group frequency-input-group has-validation"
                                                id="select-frequency"
                                            >
                                                <input
                                                    className="cron form-control"
                                                    id="cron_string"
                                                    autoComplete="off"
                                                    data-instance-path="/cronString"
                                                    onInput={() =>
                                                        handleCronInput(true)
                                                    }
                                                    onChange={(e) => {
                                                        if (!e.target.value) {
                                                            setIsCronPresent(
                                                                false
                                                            );
                                                        } else {
                                                            setIsCronPresent(
                                                                true
                                                            );
                                                        }
                                                    }}
                                                    type="text"
                                                    name="cron_string"
                                                    style={{ display: "none" }}
                                                    required = {modalType === "rule"}
                                                />

                                                <input
                                                    className="frequency form-control"
                                                    id="frequency-label"
                                                    defaultValue="Once in"
                                                    disabled={true}
                                                />

                                                <input
                                                    className="frequency form-control w-25"
                                                    id="frequency-value"
                                                    onInput={generateCron}
                                                    data-instance-path="/frequency/value"
                                                    type="number"
                                                    name="frequency_value"
                                                    max={365}
                                                    min={1}
                                                    defaultValue={
                                                        isEdit
                                                            ? rule.frequency_value
                                                            : null
                                                    }
                                                    required={!isCronPresent && modalType === "rule"}   
                                                />
                                                <select
                                                    className="frequency form-select w-25"
                                                    id="frequency-units"
                                                    onInput={generateCron}
                                                    data-instance-path="/frequency/unit"
                                                    aria-describedby="frequency_units"
                                                    name="frequency_units"
                                                    defaultValue={
                                                        isEdit
                                                            ? rule.frequency_units
                                                            : null
                                                    }
                                                    required
                                                >
                                                    <option disabled>
                                                        Select frequency
                                                    </option>
                                                    <option value="day">
                                                        day
                                                    </option>
                                                    <option value="week">
                                                        week
                                                    </option>
                                                    <option value="month">
                                                        month
                                                    </option>
                                                    <option value="year">
                                                        year
                                                    </option>
                                                </select>
                                                <span className="valid-feedback" />
                                                <span className="invalid-feedback" />
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    id="exclude"
                                                    type="checkbox"
                                                    data-instance-path="/excludeYesterday"
                                                    name="exclude"
                                                    defaultValue="exclude_yesterday"
                                                    defaultChecked={
                                                        isEdit
                                                            ? rule.exclude_yesterday
                                                            : false
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="exclude_yesterday"
                                                />
                                                Exclude Yesterday
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label
                                            className="form-label"
                                            htmlFor="desc"
                                        >
                                            Description
                                        </label>
                                        <textarea
                                            className="form-control"
                                            id="action-description"
                                            rows={3}
                                            name="action-description"
                                            data-instance-path="/description"
                                            defaultValue={
                                                isEdit ? rule.description : null
                                            }
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </Modal>
                    {editRulesFilterModalData.show && (
                        <EditRulesFiltersModal
                            {...{
                                editRulesFilterModalData,
                                setEditRulesFilterModalData,
                            }}
                            rule={editRulesFilterModalData.data || rule.filter}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default AddRulesModal;
